function DashboardCtrl($rootScope, $scope, $state, $stateParams, $timeout, toastr, DashboardService, AppContextService, UserService, PlanService, PermissionService) {
  'ngInject';

  // ViewModel
  const vm = this;
  vm.appContext = AppContextService.context;

  if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
    vm.isDebugger = true;
  }

  // 대시보드의 동영상 위에 경기, 훈련 관련 정보를 표시하기 위해서
  // 일정을 먼저 조회한 후 대시보드 조회

  // 일정 조회 시작
  vm.events = [];

  var planData = {
    login_id: vm.appContext.user.login_id,
    uuid: vm.appContext.user.uuid
  }

  // 전체관리자가 선택한 team_id
  if ($stateParams.manager_admin_team_id) {
    planData.team_id = $stateParams.manager_admin_team_id;
  }
  // 팬이 선택한 team_id
  else if ($stateParams.fan_team_id) {
    planData.team_id = $stateParams.fan_team_id;
  }
  // 팬이 선택한 user_id
  else if ($stateParams.fan_user_id) {
    planData.user_id = $stateParams.fan_user_id;
    if ($stateParams.fan_user_team_id) {
      planData.team_id = $stateParams.fan_user_team_id;
    }
  }
  // 감독-선수 소속팀 관련 수정
  // 감독-선수가 선택한 team_id
  else if ($stateParams.coach_player_team_id) {
    planData.team_id = $stateParams.coach_player_team_id;
  }

  PlanService.plans(planData).then(function (res) {
      vm.events = res.data.plans;

      if ((!$stateParams.team_id || $stateParams.team_id == '0') && !$stateParams.fan_user_team_id) {
        vm.events = [];
      }

        // 대시보드 조회 시작
        vm.dashboard = {};

        vm.types = ['game_list', 'training_list', 'health_list', 'recovery_list'];

        var data = {
          login_id: vm.appContext.user.login_id
        };
        
        // 전체관리자가 선택한 team_id
        if ($stateParams.manager_admin_team_id) {
          data.team_id = $stateParams.manager_admin_team_id;
        }
        // 팬이 선택한 team_id
        else if ($stateParams.fan_team_id) {
          data.team_id = $stateParams.fan_team_id;
        }
        // 팬이 선택한 login_id
        else if ($stateParams.fan_login_id) {
          data.login_id = $stateParams.fan_login_id;
          if ($stateParams.fan_user_team_id) {
            data.team_id = $stateParams.fan_user_team_id;
          }
        }
        // 감독-선수 소속팀 관련 수정
        // 감독-선수가 선택한 team_id
        else if ($stateParams.coach_player_team_id) {
          data.team_id = $stateParams.coach_player_team_id;
        }

        DashboardService.list(data)
          .then(function (res) {
            vm.dashboard = res.data;

            _.forEach(vm.dashboard.lists, item => {
              _.map(item.list[0].videos, video => {
                var event,
                  result;
                if (item.type === '경기') {
                  event = _.find(vm.events, {
                    id: video.game_id
                  });

                  if (event && event.oppo_name) {
                    if (event.goals === event.lost_points) {
                      result = '무';
                    } else if (event.goals > event.lost_points) {
                      result = '승';
                    } else {
                      result = '패';
                    }

                    video.title2 = event.oppo_name + ' ' + event.lost_points + ' - ' + event.goals + ' ' + result;
                  }
                } else if (item.type === '훈련') {
                  
                }

                video.type = item.type;

                if (video.url.indexOf('?v=') > -1) {
                  video.image = 'https://img.youtube.com/vi/' + video.url.split('=')[1] + '/0.jpg';
                } else {
                  video.image = 'https://img.youtube.com/vi/' + video.url.substring((video.url).lastIndexOf('/') + 1) + '/0.jpg';
                }
              });
            });

            
            _.forEach(vm.dashboard.lists, item => {
              _.forEach(item.list[0].contents, function(content) {
                if (item.type === '훈련') {
                  var data = {
                    login_id: vm.appContext.user.login_id,
                    uuid: vm.appContext.user.uuid,
                    'training_id': content.url,
                  };
              
                  PlanService.getMurls(data)
                    .then(function (res) {
                      var trainingVideo = _.find(res.data.murls, {
                        id: video.id
                      });
    
                      if (trainingVideo) {
                        var trainingData = {
                          login_id: vm.appContext.user.login_id,
                          uuid: vm.appContext.user.uuid,
                          training_root_id: data.training_id
                        };
                
                        PlanService.getTraining(trainingData)
                          .then(function (res) {
                            video.training_id = data.training_id;
                            video.title2 = res.data.plan_name;
                          }).catch(function(err) {
                            console.log(err);
                          });
                      }
                    })
                    .catch(function (error) {
                      console.log("An error occured : " + error);
                    });
                }
              });
            });


            // vm.someobj = res.data;
          }).catch(function (e) {
            console.log('ERROR ' + e);
          });
        // 대시보드 조회 끝

    })
    .catch(function (e) {
      console.log('ERROR', e);
    });
  // 일정 조회 끝

  UserService.info({
    'user_id': vm.appContext.user.user_id
  }).then(function (res) {
    vm.country_name = res.data.country_name;
    vm.team_name = res.data.team_name;
  }).catch(function (e) {
    console.log('ERROR ' + e);
  });

  vm.goToEvent = function($event, type, id) {
    $event.stopPropagation();

    // 권한 체크
    vm.appContext.permissionCheck(vm, 'Service.event').then(
      // 권한이 있는 경우
      function() {
        return true;
      },
      // 권한이 없는 경우
      function() {
        return false;
      })
      .then(function(eventPermission) {
        if (eventPermission) {
          if (type === '경기') {
            $state.go('Service.eventDetail', {id:id, type_code:'game', type_name:'경기'});
          } else if (type === '훈련') {
            $state.go('Service.eventDetail', {id:id, type_code:'training', type_name:'훈련'});
          }
        } else {
          toastr.error('결제 후 사용하실 수 있습니다.');
        }
      }).catch(function(err) {
        console.log(err);
      });
  };

  $scope.$on('youtube.player.ready', function ($event, player) {
    $rootScope.YTPlayer = player;
  });

}


export default {
  name: 'DashboardCtrl',
  fn: DashboardCtrl
};
